export default {
  nav_spreadsheet: "Regneark",
  nav_categories: "Kategorier",
  nav_guides: "Guides",
  nav_reviews: "Anmeldelser",
  nav_shipping: "Forsendelse",
  nav_safety: "Sikkerhed",
  nav_language: "Sprog",

  hero_eyebrow: "RESSOURCECENTERET FOR ALLCHINABUY SPREADSHEET",
  hero_title: "AllChinaBuy Spreadsheet — Find Produkter, Links & Købsguider",
  hero_subtitle: "Opdag organiserede AllChinaBuy spreadsheet-ressourcer, produktlinks, købsguider, QC-tips, forsendelsesinformation og nyttige værktøjer — alt på ét sted.",
  hero_cta_primary: "Udforsk AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Gennemse Populære Kategorier",
  hero_trust: "Uafhængig ressource • Regelmæssigt opdateret • Sikkerhedsfokuseret",

  categories_title: "Shop efter Kategori",
  categories_description: "Gennemse vores udvalgte kategorier og find præcis det, du har brug for",
  categories_button: "Alle Kategorier",

  cta_spreadsheet: "AllChinaBuy Spreadsheet",
  cta_buy_now: "Køb Nu",
  cta_explore: "Udforsk Produkter",

  value_title: "Alt hvad du har brug for til at Navigere AllChinaBuy",
  value_spreadsheet: "Spreadsheet-ressourcer",
  value_spreadsheet_desc: "Find organiserede spreadsheet-ressourcer og produktreferencer.",
  value_discovery: "Produktopdagelse",
  value_discovery_desc: "Udforsk populære kategorier og opdag nyttige produktinformationer.",
  value_qc: "QC-guides",
  value_qc_desc: "Lær at evaluere kvalitetskontrolfotos og produktdetaljer.",
  value_shipping: "Forsendelsesguides",
  value_shipping_desc: "Forstå forsendelsesmuligheder, omkostninger, sporing og vigtige overvejelser.",
  value_safety: "Sikkerhedscenter",
  value_safety_desc: "Lær at reducere almindelige købs-, betalings- og sælgerrisici.",
  value_comparison: "Sammenligningsguides",
  value_comparison_desc: "Sammenlign købsplatforme, funktioner og brugerovervejelser.",

  popular_title: "Populære AllChinaBuy Spreadsheet Kategorier",
  popular_desc: "Udforsk vores mest besøgte produktkategorier og opdag trending varer",

  how_title: "Sådan Bruger du et AllChinaBuy Spreadsheet",
  how_step1_title: "Vælg en Kategori",
  how_step1_desc: "Gennemse produkter efter kategori og hensigt.",
  how_step2_title: "Gennemgå Produktinformation",
  how_step2_desc: "Tjek tilgængelig information, referencer og QC-overvejelser.",
  how_step3_title: "Sammenlign Muligheder",
  how_step3_desc: "Brug sammenligningstabeller og guides før du træffer beslutninger.",
  how_step4_title: "Fortsæt til Hovedwebstedet",
  how_step4_desc: "Brug det relevante CTA, når du er klar til at fortsætte.",

  trust_title: "Bygget til Klogere Købsresearch",
  trust_desc: "AllChinaBuySpreadsheet.fit er en uafhængig informationsressource designet til at organisere nyttige spreadsheet-ressourcer og købsinformation. Vi fokuserer på klarhed, praktisk vejledning, sikkerhed og regelmæssigt opdateret indhold.",
  trust_point1: "Uafhængig ressource",
  trust_point2: "Gennemsigtig information",
  trust_point3: "Sikkerhedsfokuserede guides",
  trust_point4: "Regelmæssige indholdsopdateringer",
  trust_point5: "Klare redaktionelle standarder",

  articles_title: "Seneste AllChinaBuy Spreadsheet Guides",
  articles_desc: "Læs vores dybdegående artikler for at blive en klogere køber",
  articles_read_more: "Læs Mere",
  articles_category: "Kategori",
  articles_read_time: "Læsetid",

  final_cta_title: "Klar til at Udforske AllChinaBuy Spreadsheet?",
  final_cta_desc: "Gennemse de seneste ressourcer, opdag nyttige kategorier og lær at navigere købsprocessen med mere selvtillid.",
  final_cta_primary: "Udforsk AllChinaBuy Spreadsheet",
  final_cta_secondary: "Læs Begynderguiden",

  footer_tagline: "Din uafhængige ressource for AllChinaBuy spreadsheet-ressourcer og købsguider.",
  footer_resources: "Ressourcer",
  footer_spreadsheet: "Spreadsheet Hub",
  footer_categories: "Kategorier",
  footer_guides: "Guides",
  footer_reviews: "Anmeldelser",
  footer_legal: "Juridisk",
  footer_about: "Om Os",
  footer_privacy: "Privatlivspolitik",
  footer_terms: "Servicevilkår",
  footer_disclaimer: "Ansvarsfraskrivelse",
  footer_contact: "Kontakt",
  footer_email: "Email Os",
  footer_social: "Følg Os",
  footer_copyright: "AllChinaBuySpreadsheet.fit. Alle rettigheder forbeholdes.",
  footer_independent: "Dette er et uafhængigt ressourcecenter. Vi er ikke tilknyttet AllChinaBuy.",

  article_back: "Tilbage til Hjem",
  article_updated: "Sidst Opdateret",
  article_share: "Del denne artikel",
  article_related: "Relaterede Artikler",
  article_read_more: "Læs Mere",
  article_author: "Redaktionelt Team",
  article_table_of_contents: "Indholdsfortegnelse",
  article_jump_to: "Hop til sektion",

  safety_title: "Shop Klogere Med Vores Sikkerhedsguides",
  safety_desc: "Før du bruger et produktlink eller afgiver en bestilling, lær at evaluere sælgere, produktinformation, QC-fotos, betalingsmetoder og forsendelsesrisici.",
  safety_cta: "Besøg Sikkerhedscentret",
  safety_notice: "Bekræft altid aktuel produkt-, sælger-, betalings- og forsendelsesinformation før bestilling. Detaljer kan ændre sig over tid.",

  comparison_title: "AllChinaBuy & Populære Købsplatforme",
  comparison_note: "Bekræft aktuel information før bestilling.",
  comparison_platform: "Platform",
  comparison_spreadsheet: "Spreadsheet-ressourcer",
  comparison_qc: "QC",
  comparison_shipping_info: "Forsendelsesinformation",
  comparison_beginner: "Begyndervenlig",

  read_guide: "Læs Guide",
  learn_more: "Læs Mere",
  search_placeholder: "Søg efter AllChinaBuy spreadsheets, produkter, kategorier eller guides...",
  search_title: "Find Hvad du Leder Efter",
  search_suggested: "Foreslåede søgninger",
  featured_spreadsheet: "AllChinaBuy Spreadsheet",
  featured_spreadsheet_desc: "Start med den vigtigste ressource på dette websted. Udforsk organiseret spreadsheet-information, kategorier, produktreferencer og praktisk købsvejledning.",
  explore_spreadsheet: "Udforsk Spreadsheet",
  home_breadcrumb: "Hjem",
  article_breadcrumb: "Artikler",
  scroll_to_top: "Tilbage til top",
  main_website: "Hovedwebsted",
  visit_main: "Besøg Hovedwebsted",

  // Products
  products_title: "Alle Produkter fra Kakobuy Spreadsheet",
  products_subtitle: "Gennemse vores komplette samling af kuraterede produkter med direkte købslinks",
  products_view_all: "Se alle {category}",
  products_buy_now: "Køb Nu",
  products_from: "Fra",
};